export const LOF_DISPLAY_NAMES: Record<string, string> = {
  ER: 'งานอุบัติเหตุ และฉุกเฉิน',
  OPD1: 'งานผู้ป่วยนอก 1',
  OPD2: 'งานผู้ป่วยนอก 2',
  OPD3: 'งานผู้ป่วยนอก 3',
  HR: 'งานทรัพยากรบุคคล',
  OR_LOF: 'งานผ่าตัด',
  OBGYN: 'งานสูติ-นรีเวชกรรม',
  SPE: 'งานเฉพาะทาง และกุมารเวชกรรม',
  SUR1: 'งานศัลยกรรม 1',
  SUR2: 'งานศัลยกรรม 2',
  MED1: 'งานอายุรกรรม 1',
  MED2: 'งานอายุรกรรม 2',
  ICU: 'งานผู้ป่วยวิกฤต',
  NSO: '',
  SN: 'สายงานการพยาบาล',
};

/** Soft-retired LOF ids stay in Firestore for history and are hidden from new assignment pickers. */
export const INACTIVE_LOF_IDS = ['OPD3'] as const;

/** Map common typos to canonical LOF IDs (per firestore-canonical-ids rule). */
const LOF_TYPO_CORRECTIONS: Record<string, string> = {
  OF_LOF: 'OR_LOF',
};

export function normalizeLofId(lofId: string): string {
  const trimmed = (lofId ?? '').trim();
  return LOF_TYPO_CORRECTIONS[trimmed] ?? trimmed;
}

/** Shown when a work line has no stored name. Never a document id. */
export const WORK_LINE_UI_FALLBACK = 'สายงาน';

const LOF_ID_SHAPE = /^[A-Za-z0-9_]+$/;

/**
 * Catalog name for a work-line id.
 * `NSO` stays empty on purpose. Unknown ids return an empty string, not the id.
 */
export const getLofDisplayName = (lofId: string): string => {
  const key = normalizeLofId(lofId);
  if (Object.prototype.hasOwnProperty.call(LOF_DISPLAY_NAMES, key)) {
    return LOF_DISPLAY_NAMES[key] ?? '';
  }
  return '';
};

/** Staff-facing work-line label. Never returns a document id. */
export function lofLabelForUi(lofId: string, explicitName?: string | null): string {
  const named = String(explicitName ?? '').trim();
  if (named && !LOF_ID_SHAPE.test(named)) return named;
  const fromCatalog = getLofDisplayName(lofId).trim();
  if (fromCatalog) return fromCatalog;
  return WORK_LINE_UI_FALLBACK;
}

/** `<option value>` stays the id. The visible label is the Thai name. */
export function lofSelectOptions(currentId?: string | null): { value: string; label: string }[] {
  const ids = Object.keys(LOF_DISPLAY_NAMES);
  const current = String(currentId ?? '').trim();
  const normalized = current ? normalizeLofId(current) : '';
  const ordered =
    normalized && !ids.includes(normalized) && !ids.includes(current) ? [current, ...ids] : ids;
  return ordered.map((id) => ({ value: id, label: lofLabelForUi(id) }));
}
